import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';
import { Capacitor } from '@capacitor/core';
import { FeatureCatalogSnapshot } from './feature.service';


interface NewFeatureEntry
{
  expirationDate:string;
  minimumDays:number;
  boardSkuList:string[];
  instrumentSkuList:string[];
  featuresSkuList:string[];
}


var allSkuInstr=[
     "piano-webfont",
    "sitar-real",
    "veena-real",
    "sarangi-real",
    "guitar-nylon-web",
    "flute-sarega",
    "strings-web",
    "violin-sarega",
    "SopranoSax-sarega",
    "tenorsax-sarega",
    "accordion-sarega",
    "swarmandal-sarega",
    "ravanhatta-sarega",
    "harmonium--dr-sarega",
    "bansuri-sarega",
   "viola-webfont",
   "cello-webfont",
   "contrabass-webfont",
   "tremolo-strings-webfont",
   "pizzicato-strings-webfont",
   "orchestral-harp-webfont",
   "timpani-webfont",
   "string-ensemble1-webfont",
   "string-ensemble2-webfont",
   "trumpet-webfont",
   "trombone-webfont",
   "tuba-webfont",
   "muted-trumpet-webfont",
   "french-horn-webfont",
   "brass-section-webfont",
   "synth-brass1-webfont",
   "alto-sax-webfont",
   "baritone-sax-webfont",
   "oboe-webfont",
   "english-horn-webfont",
   "bassoon-webfont",
   "clarinet-webfont",
   "piccolo-webfont",
   "recorder-webfont",
   "pan-flute-webfont",
   "whistle-webfont",
   "ocarina-webfont",

]
enum Features
{
    RECORD="Record",
    SAVE="Save Settings with name",
    SAVE_DEFAULT="Save Last Used",
    MIDIHOST="Midi Host",
    MIDISOURCE="Midi Source",
    CONFIGURE="Configure",
    SHARE="Share",
    ADS="Contain Ads",
    NOADS="Contain No ads for valid boards"
}
class  TierData
{
    tierName:string="";
    boardSku:string[]=[];
    instrumentsSku:string[]=[];
    features:Features[]=[];
    bannerads:boolean=true;
    interAds:boolean=true;
    constructor(tierName:string)
    {
        this.tierName=tierName;
    }

}

export var freeTier=new TierData("free");
freeTier.bannerads=true;
freeTier.interAds=true;
freeTier.boardSku=["yaman","khamaj-raag","bhoop-raag"];
freeTier.instrumentsSku=["piano-webfont","guitar-nylon-web","trumpet-webfont","cello-webfont","strings-web"];
freeTier.features=[Features.ADS];

export var bronzeTier=new TierData("Bronze");
bronzeTier.bannerads=false;
bronzeTier.interAds=false;
bronzeTier.features=[Features.SAVE_DEFAULT,Features.NOADS];
bronzeTier.boardSku=[...freeTier.boardSku , ...[
    "aasavari-all",
"bhairav-all",
"bhairavi-thaat",
"bhoop-raag",
"bilawal-thaat",
//"des-raag",
"raag-durga",
"kafi-thaat",
//"kafi-raag",
"kalyan-thaat",
"default-keyboard",
"khamaj-thaat",
"khamaj-raag",
//"malkauns",
"marava-thaat",
//"mishra-kafi",
"purabi-thaat",
//"purabi-raag",
"todi-thaat",
"western-default-keyboard",
"yaman",
    
]];
bronzeTier.instrumentsSku=[... freeTier.instrumentsSku ,...[
     "piano-webfont",
    "sitar-real",
    //"veena-real",
   // "sarangi-real",
    "guitar-nylon-web",
    "flute-sarega",
    "strings-web",
    "violin-sarega",
    "SopranoSax-sarega",
    "tenorsax-sarega",
    "accordion-sarega",
    "swarmandal-sarega",
   // "ravanhatta-sarega",
    "harmonium--dr-sarega",
    "bansuri-sarega",
   "viola-webfont",
   "cello-webfont",
   "contrabass-webfont",
   //"tremolo-strings-webfont",
   //pizzicato-strings-webfont",
   "orchestral-harp-webfont",
   //"timpani-webfont",
   //"string-ensemble1-webfont",
   "string-ensemble2-webfont",
   "trumpet-webfont",
   //"trombone-webfont",
   //"tuba-webfont",
   "muted-trumpet-webfont",
   "french-horn-webfont",
   "brass-section-webfont",
   "synth-brass1-webfont",
   //"alto-sax-webfont",
   //"baritone-sax-webfont",
  // "oboe-webfont",
   "english-horn-webfont",
   "bassoon-webfont",
  // "clarinet-webfont",
   "piccolo-webfont",
   "recorder-webfont",
   "pan-flute-webfont",
   "whistle-webfont",
   "ocarina-webfont",

    
]];





export var silverTier=new TierData("Silver");
silverTier.bannerads=false;
silverTier.interAds=false;
silverTier.boardSku=[...bronzeTier.boardSku , ...[
  
"des-raag",

"kafi-raag",
"malkauns",

"mishra-kafi",
"purabi-raag",

    
]];
silverTier.instrumentsSku=[... silverTier.instrumentsSku ,...[
    
    "veena-real",
   "sarangi-real",
    
    "ravanhatta-sarega",
    
   "tremolo-strings-webfont",
   "pizzicato-strings-webfont",
   
   "timpani-webfont",
   "string-ensemble1-webfont",
  
   "trombone-webfont",
   "tuba-webfont",
   
   "alto-sa,x-webfont",
   "baritone-sax-webfont",
   "oboe-webfont",
   
  "clarinet-webfont",
   
    
]];
silverTier.features=[Features.SAVE, Features.SAVE_DEFAULT,
    Features.RECORD,Features.NOADS
];


const newFeatureSkuCatalog :NewFeatureEntry[]=
[
{
  expirationDate:"2026-03-31",
  minimumDays:7,
  boardSkuList:[ "aasavari-all",
"bhairav-all",
"bhairavi-thaat",
"bhoop-raag",
"bilawal-thaat",
//"des-raag",
"raag-durga",
"kafi-thaat",
//"kafi-raag",
"kalyan-thaat",
"default-keyboard",
"khamaj-thaat",
"khamaj-raag",
//"malkauns",
"marava-thaat",
//"mishra-kafi",
"purabi-thaat",
//"purabi-raag",
"todi-thaat",
"western-default-keyboard",
"yaman",
    ],
    instrumentSkuList:[
      "sitar-real",
    "veena-real",
    "sarangi-real",
    "guitar-nylon-web",
    "flute-sarega",
    "strings-web",
    "violin-sarega",
    "SopranoSax-sarega",
    "tenorsax-sarega",
    "accordion-sarega",
    "swarmandal-sarega",
    "ravanhatta-sarega",
    "harmonium--dr-sarega",
    "bansuri-sarega",
      "piano-webfont"
    
    ],featuresSkuList:[Features.ADS]}

];
export var goldTier=new TierData("Gold - comming soon");

var ourProducts={

    raagastudio:{

        subscriptionData:{
            discontinued:['diamondmonth','raagasix','raagagold'],
            currentProductIds:['raagagoldquarter','raagasubsilver3']

        },
        productData:{
            discontinued:['diamondpass','goldpass','goldpass66'],
            currentProductIds:[]

        }
    }
}
export interface CatalogGroup {
  discontinuedProductIds: string[];
  currentProductIds: string[];
}

export interface OfferingsByProduct {
  [productId: string]: string[];
}

export interface StoreProductSnapshot {
  productId: string;
  isSubscription: boolean;
  title?: string;
  description?: string;
  currency?: string;
  price?: string;
  priceMicros?: number;
  state?: string;
  owned?: boolean;
  canPurchase?: boolean;
  billingPeriod?: number;
  billingPeriodUnit?: string;
  introPrice?: string;
  introPriceMicros?: number;
  introPricePeriod?: number;
  introPricePeriodUnit?: string;
  introPricePaymentMode?: string;
  purchaseDate?: Date;
  lastRenewalDate?: Date;
  expiryDate?: Date;
  offers: StoreOfferingSnapshot[];
}

export interface StoreOfferingSnapshot {
  offeringId: string;
  productId: string;
  title?: string;
  price?: string;
  priceMicros?: number;
  currency?: string;
  billingPeriod?: number;
  billingPeriodUnit?: string;
  introPrice?: string;
  introPriceMicros?: number;
  introPricePeriod?: number;
  introPricePeriodUnit?: string;
  introPricePaymentMode?: string;
}

export interface StoreTransactionSnapshot {
  transactionId: string;
  productId: string;
  state?: string;
  verified?: boolean;
  purchaseDate?: Date;
  lastRenewalDate?: Date;
  expiryDate?: Date;
}

export interface PurchasedProductSnapshot {
  productId: string;
  isSubscription: boolean;
  isActive: boolean;
  state?: string;
  purchaseDate?: Date;
  expiryDate?: Date;
  lastRenewalDate?: Date;
  transactionId?: string;
  source: 'store' | 'cache';
  currency?: string;
  price?: string;
}

export interface StoreSnapshot {
  platform: string;
  products: StoreProductSnapshot[];
  offerings: StoreOfferingSnapshot[];
  transactions: StoreTransactionSnapshot[];
  purchasedProducts: PurchasedProductSnapshot[];
}

export interface PurchaseResult {
  ok: boolean;
  orderedId: string;
  productId: string;
  offeringId?: string;
  purchasedProduct?: PurchasedProductSnapshot;
}

export type AccessTierName = 'free' | 'bronze' | 'silver' | 'gold';

export interface AccessUserData {
  firstLogin?: Date | string | number | null;
  tier?: AccessTierName | null;
  purchasedProducts?: PurchasedProductSnapshot[] | null;
  isAnonymous?: boolean | null;
}

export interface SkuAccessDecision {
  sku: string;
  isAllowed: boolean;
  requiredTier?: AccessTierName;
  effectiveTier: AccessTierName;
  reason: string;
  grantedBy: 'tier' | 'new-feature-window' | 'none';
  validFrom?: string;
  validUntil?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProductStoreService {
  private readonly savedPurchaseKey = 'savedPurchase';
  private defaultValidatorUrl =
    'https://validator.fovea.cc/v1/validate?appName=raagastudio&apiKey=f4be4a05-e1da-4d37-95cd-19dfc8db24ed';

  private initialized = false;
  private listenersBound = false;

  private productData: CatalogGroup = { discontinuedProductIds: [], currentProductIds: [] };
  private subscriptionData: CatalogGroup = { discontinuedProductIds: [], currentProductIds: [] };
  private offeringsByProduct: OfferingsByProduct = {};

  private productsMap = new Map<string, StoreProductSnapshot>();
  private transactionsMap = new Map<string, StoreTransactionSnapshot>();
  private offeringsMap = new Map<string, StoreOfferingSnapshot>();

  private readonly snapshotSubject = new BehaviorSubject<StoreSnapshot>({
    platform: Capacitor.getPlatform(),
    products: [],
    offerings: [],
    transactions: [],
    purchasedProducts: []
  });

  readonly snapshot$ = this.snapshotSubject.asObservable();
  private readonly silverSubscriptionSkus = new Set<string>(['raagasubsilver3']);
  private readonly goldSubscriptionSkus = new Set<string>([
    'raagagoldquarter',
    'raagagold',
    'raagasix',
    'diamondmonth'
  ]);
  private readonly lifetimeGoldSkus = new Set<string>(['goldpass', 'goldpass66', 'diamondpass']);
  private readonly tierOrder: Record<AccessTierName, number> = {
    free: 0,
    bronze: 1,
    silver: 2,
    gold: 3
  };

  constructor(
    private readonly platform: Platform,
    private readonly store: InAppPurchase2,
    private readonly zone: NgZone
  ) {}

  async init(
    productData: CatalogGroup,
    subscriptionData: CatalogGroup,
    offeringsByProduct: OfferingsByProduct = {},
    validatorUrl?: string
  ): Promise<StoreSnapshot> {
    await this.platform.ready();

    this.productData = this.normalizeCatalog(productData);
    this.subscriptionData = this.normalizeCatalog(subscriptionData);
    this.offeringsByProduct = offeringsByProduct || {};

    const platformName = Capacitor.getPlatform();
    if (platformName !== 'ios' && platformName !== 'android') {
      this.initialized = true;
      this.publishSnapshot();
      return this.snapshotSubject.value;
    }

    this.store.verbosity = this.store.DEBUG;
    this.store.validator = validatorUrl || this.defaultValidatorUrl;

    if (!this.listenersBound) {
      this.bindStoreListeners();
      this.listenersBound = true;
    }

    this.registerCatalogProducts();
    await this.refresh();

    this.initialized = true;
    return this.snapshotSubject.value;
  }

  async refresh(): Promise<StoreSnapshot> {
    const platformName = Capacitor.getPlatform();
    if (platformName !== 'ios' && platformName !== 'android') {
      this.publishSnapshot();
      return this.snapshotSubject.value;
    }

    await new Promise<void>((resolve) => {
      const refreshResult = this.store.refresh();
      refreshResult.finished(() => resolve());
      refreshResult.cancelled(() => resolve());
      refreshResult.failed(() => resolve());
    });

    this.publishSnapshot();
    return this.snapshotSubject.value;
  }

  getSnapshot(): StoreSnapshot {
    return this.snapshotSubject.value;
  }

  getPurchasedProducts(): PurchasedProductSnapshot[] {
    return this.snapshotSubject.value.purchasedProducts;
  }

  getProduct(productId: string): StoreProductSnapshot | undefined {
    return this.productsMap.get(productId);
  }

  getOfferingsForProduct(productId: string): StoreOfferingSnapshot[] {
    return Array.from(this.offeringsMap.values()).filter((o) => o.productId === productId);
  }

  getTransactionsForProduct(productId: string): StoreTransactionSnapshot[] {
    return Array.from(this.transactionsMap.values()).filter((t) => t.productId === productId);
  }

  async transact(productId: string): Promise<any> {
    const platformName = Capacitor.getPlatform();
    if (platformName !== 'ios' && platformName !== 'android') {
      throw new Error('Transactions are only supported on iOS/Android');
    }

    return await new Promise((resolve, reject) => {
      try {
        const orderResult = (this.store as any).order(productId);
        if (orderResult && typeof orderResult.then === 'function') {
          orderResult.then(resolve).catch(reject);
          return;
        }
        if (orderResult && typeof orderResult.error === 'function') {
          orderResult.error(reject);
          resolve(orderResult);
          return;
        }
        resolve(orderResult);
      } catch (err) {
        reject(err);
      }
    });
  }

  setValidatorUrl(url: string): void {
    if (!url?.trim()) return;
    this.defaultValidatorUrl = url.trim();
    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      this.store.validator = this.defaultValidatorUrl;
    }
  }

  async validateProduct(productId: string): Promise<StoreProductSnapshot | undefined> {
    const platformName = Capacitor.getPlatform();
    if (platformName !== 'ios' && platformName !== 'android') {
      throw new Error('Validation is only supported on iOS/Android');
    }

    const product: any = (this.store as any).get(productId);
    if (!product) {
      throw new Error(`Product not found in store: ${productId}`);
    }

    if (typeof product.verify === 'function') {
      product.verify();
    }

    const result = await this.waitForPurchasedProduct(productId, 30000);
    if (!result) {
      return this.getProduct(productId);
    }
    return this.getProduct(productId);
  }

  async purchase(productId: string, offeringId?: string): Promise<PurchaseResult> {
    const platformName = Capacitor.getPlatform();
    if (platformName !== 'ios' && platformName !== 'android') {
      throw new Error('Purchase is only supported on iOS/Android');
    }
    if (!productId?.trim()) {
      throw new Error('productId is required');
    }

    const preferredId = offeringId?.trim();
    const orderedId = preferredId || productId;

    if (preferredId) {
      try {
        await this.orderId(preferredId);
      } catch {
        await this.orderId(productId);
      }
    } else {
      await this.orderId(productId);
    }

    const purchasedProduct = await this.waitForPurchasedProduct(productId, 60000);
    if (!purchasedProduct) {
      throw new Error(`Purchase submitted but not verified/owned yet for ${productId}`);
    }

    return {
      ok: true,
      orderedId,
      productId,
      offeringId: preferredId,
      purchasedProduct
    };
  }

  async restorePurchases(): Promise<StoreSnapshot> {
    await this.refresh();
    return this.snapshotSubject.value;
  }

  manageSubscriptions(): void {
    if (typeof this.store.manageSubscriptions === 'function') {
      this.store.manageSubscriptions();
    }
  }

  manageBilling(): void {
    if (typeof (this.store as any).manageBilling === 'function') {
      (this.store as any).manageBilling();
    }
  }

  private normalizeCatalog(data: CatalogGroup | null | undefined): CatalogGroup {
    return {
      discontinuedProductIds: [...(data?.discontinuedProductIds || [])],
      currentProductIds: [...(data?.currentProductIds || [])]
    };
  }

  private registerCatalogProducts(): void {
    const allProducts = this.getAllIds(this.productData);
    const allSubscriptions = this.getAllIds(this.subscriptionData);
    const subscriptionSet = new Set(allSubscriptions);
    const allIds = Array.from(new Set([...allProducts, ...allSubscriptions]));

    for (const id of allIds) {
      if (!id) continue;
      this.store.register({
        id,
        type: subscriptionSet.has(id) ? this.store.PAID_SUBSCRIPTION : this.store.NON_CONSUMABLE
      });

      const knownOffers = this.offeringsByProduct[id] || [];
      for (const offerId of knownOffers) {
        this.store.register({
          id: offerId,
          type: subscriptionSet.has(id) ? this.store.PAID_SUBSCRIPTION : this.store.NON_CONSUMABLE
        });
      }
    }
  }

  private bindStoreListeners(): void {
    this.store.when('product').approved((product: any) => {
      if (typeof product?.verify === 'function') {
        product.verify();
      }
    });

    this.store.when('product').verified((product: any) => {
      this.zone.run(() => {
        const tx = this.toTransactionSnapshot(product, true);
        if (tx) {
          this.transactionsMap.set(tx.transactionId, tx);
          this.addToSavedVerified({
            id: tx.productId,
            expiryDate: tx.expiryDate?.toISOString?.() || tx.expiryDate
          });
        }

        if (typeof product?.finish === 'function') {
          product.finish();
        }

        this.upsertProduct(product);
        this.publishSnapshot();
      });
    });

    this.store.when('product').unverified((product: any) => {
      if (typeof product?.finish === 'function') {
        product.finish();
      }
    });

    this.store.when('product').expired((product: any) => {
      this.zone.run(() => {
        this.upsertProduct(product);
        this.publishSnapshot();
      });
    });

    this.store.when('product').updated((product: any) => {
      this.zone.run(() => {
        this.upsertProduct(product);
        const tx = this.toTransactionSnapshot(product, false);
        if (tx) {
          this.transactionsMap.set(tx.transactionId, tx);
        }
        this.publishSnapshot();
      });
    });

    this.store.error((err: any) => {
      console.error('[ProductStore] store error', err);
    });
  }

  private upsertProduct(product: any): void {
    if (!product?.id) return;

    const isSubscription = this.isSubscriptionId(product.id);
    const productSnapshot: StoreProductSnapshot = {
      productId: product.id,
      isSubscription,
      title: product.title,
      description: product.description,
      currency: product.currency,
      price: product.price,
      priceMicros: this.toNumber(product.priceMicros),
      state: product.state,
      owned: !!product.owned || product.state === 'owned',
      canPurchase: product.canPurchase,
      billingPeriod: this.toNumber(product.billingPeriod),
      billingPeriodUnit: product.billingPeriodUnit,
      introPrice: product.introPrice,
      introPriceMicros: this.toNumber(product.introPriceMicros),
      introPricePeriod: this.toNumber(product.introPricePeriod),
      introPricePeriodUnit: product.introPricePeriodUnit,
      introPricePaymentMode: product.introPricePaymentMode,
      purchaseDate: this.toDate(product.purchaseDate),
      lastRenewalDate: this.toDate(product.lastRenewalDate || product.lastRenewDate),
      expiryDate: this.toDate(product.expiryDate),
      offers: this.extractOfferings(product)
    };

    this.productsMap.set(product.id, productSnapshot);

    for (const offer of productSnapshot.offers) {
      this.offeringsMap.set(offer.offeringId, offer);
    }
  }

  private extractOfferings(product: any): StoreOfferingSnapshot[] {
    const offers: StoreOfferingSnapshot[] = [];
    const sourceOffers = Array.isArray(product?.offers) ? product.offers : [];

    for (const offer of sourceOffers) {
      if (!offer) continue;
      const offeringId = offer.id || offer.offerId || offer.productId;
      if (!offeringId) continue;

      offers.push({
        offeringId,
        productId: product.id,
        title: offer.title || offer.name || product.title,
        price: offer.price || product.price,
        priceMicros: this.toNumber(offer.priceMicros ?? product.priceMicros),
        currency: offer.currency || product.currency,
        billingPeriod: this.toNumber(offer.billingPeriod ?? product.billingPeriod),
        billingPeriodUnit: offer.billingPeriodUnit || product.billingPeriodUnit,
        introPrice: offer.introPrice || product.introPrice,
        introPriceMicros: this.toNumber(offer.introPriceMicros ?? product.introPriceMicros),
        introPricePeriod: this.toNumber(offer.introPricePeriod ?? product.introPricePeriod),
        introPricePeriodUnit: offer.introPricePeriodUnit || product.introPricePeriodUnit,
        introPricePaymentMode: offer.introPricePaymentMode || product.introPricePaymentMode
      });
    }

    const configOffers = this.offeringsByProduct[product.id] || [];
    for (const offeringId of configOffers) {
      if (offers.some((o) => o.offeringId === offeringId)) continue;
      offers.push({
        offeringId,
        productId: product.id,
        title: product.title,
        price: product.price,
        priceMicros: this.toNumber(product.priceMicros),
        currency: product.currency,
        billingPeriod: this.toNumber(product.billingPeriod),
        billingPeriodUnit: product.billingPeriodUnit,
        introPrice: product.introPrice,
        introPriceMicros: this.toNumber(product.introPriceMicros),
        introPricePeriod: this.toNumber(product.introPricePeriod),
        introPricePeriodUnit: product.introPricePeriodUnit,
        introPricePaymentMode: product.introPricePaymentMode
      });
    }

    return offers;
  }

  private toTransactionSnapshot(product: any, verified: boolean): StoreTransactionSnapshot | null {
    if (!product?.id) return null;

    const transactionId =
      product.transaction?.id ||
      product.transactionId ||
      `${product.id}-${this.toDate(product.purchaseDate || product.lastRenewalDate || Date.now())?.getTime()}`;

    if (!transactionId) return null;

    return {
      transactionId,
      productId: product.id,
      state: product.state,
      verified,
      purchaseDate: this.toDate(product.purchaseDate),
      lastRenewalDate: this.toDate(product.lastRenewalDate || product.lastRenewDate),
      expiryDate: this.toDate(product.expiryDate)
    };
  }

  private buildPurchasedProducts(): PurchasedProductSnapshot[] {
    const now = Date.now();
    const byProduct = new Map<string, PurchasedProductSnapshot>();

    for (const product of this.productsMap.values()) {
      const purchasedState =
        product.state === 'owned' ||
        product.state === 'approved' ||
        product.state === 'valid' ||
        !!product.owned;

      if (!purchasedState) continue;

      const expiryTime = product.expiryDate?.getTime();
      const isActive = expiryTime ? expiryTime > now : true;

      byProduct.set(product.productId, {
        productId: product.productId,
        isSubscription: product.isSubscription,
        isActive,
        state: product.state,
        purchaseDate: product.purchaseDate,
        expiryDate: product.expiryDate,
        lastRenewalDate: product.lastRenewalDate,
        transactionId: this.findLatestTransactionId(product.productId),
        source: 'store',
        currency: product.currency,
        price: product.price
      });
    }

    const cached = this.getSavedVerified();
    for (const item of cached) {
      const id = item?.id;
      if (!id || byProduct.has(id)) continue;
      const expiry = this.toDate(item.expiryDate);
      const isActive = expiry ? expiry.getTime() > now : true;

      byProduct.set(id, {
        productId: id,
        isSubscription: this.isSubscriptionId(id),
        isActive,
        state: 'cached',
        purchaseDate: this.toDate(item.purchaseDate),
        expiryDate: expiry,
        lastRenewalDate: this.toDate(item.lastRenewalDate),
        source: 'cache'
      });
    }

    return Array.from(byProduct.values());
  }

  private publishSnapshot(): void {
    const products = Array.from(this.productsMap.values());
    const offerings = Array.from(this.offeringsMap.values());
    const transactions = Array.from(this.transactionsMap.values());
    const purchasedProducts = this.buildPurchasedProducts();

    this.snapshotSubject.next({
      platform: Capacitor.getPlatform(),
      products,
      offerings,
      transactions,
      purchasedProducts
    });
  }

  private findLatestTransactionId(productId: string): string | undefined {
    const tx = Array.from(this.transactionsMap.values())
      .filter((t) => t.productId === productId)
      .sort((a, b) => {
        const at = a.purchaseDate?.getTime() || a.lastRenewalDate?.getTime() || 0;
        const bt = b.purchaseDate?.getTime() || b.lastRenewalDate?.getTime() || 0;
        return bt - at;
      })[0];

    return tx?.transactionId;
  }

  private isSubscriptionId(productId: string): boolean {
    return this.getAllIds(this.subscriptionData).includes(productId);
  }

  private getAllIds(group: CatalogGroup): string[] {
    return Array.from(new Set([...(group.currentProductIds || []), ...(group.discontinuedProductIds || [])]));
  }

  private toDate(value: any): Date | undefined {
    if (!value) return undefined;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  }

  private toNumber(value: any): number | undefined {
    if (value === null || value === undefined || value === '') return undefined;
    const num = Number(value);
    return Number.isFinite(num) ? num : undefined;
  }

  private getSavedVerified(): any[] {
    try {
      const raw = localStorage.getItem(this.savedPurchaseKey);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private addToSavedVerified(item: any): void {
    if (!item?.id) return;
    const saved = this.getSavedVerified();
    const exists = saved.some((s) => s.id === item.id && s.expiryDate === item.expiryDate);
    if (exists) return;
    saved.push(item);
    localStorage.setItem(this.savedPurchaseKey, JSON.stringify(saved));
  }

  private async orderId(id: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      try {
        const result = (this.store as any).order(id);
        if (result && typeof result.then === 'function') {
          result.then(resolve).catch(reject);
          return;
        }
        if (result && typeof result.error === 'function') {
          result.error(reject);
          resolve(result);
          return;
        }
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  }

  private async waitForPurchasedProduct(productId: string, timeoutMs: number): Promise<PurchasedProductSnapshot | undefined> {
    const started = Date.now();
    while (Date.now() - started < timeoutMs) {
      const match = this.snapshotSubject.value.purchasedProducts.find((p) => p.productId === productId && p.isActive);
      if (match) return match;
      await this.delay(250);
      await this.refresh();
    }
    return undefined;
  }

  private async delay(ms: number): Promise<void> {
    await new Promise<void>((resolve) => setTimeout(resolve, ms));
  }

  checkAccess(sku: string, userData: AccessUserData, now: Date = new Date()): SkuAccessDecision {
    const normalizedSku = (sku || '').trim();
    const effectiveTier = this.resolveEffectiveTier(userData);
    if (!normalizedSku) {
      return {
        sku: normalizedSku,
        isAllowed: false,
        effectiveTier,
        reason: 'Invalid SKU',
        grantedBy: 'none'
      };
    }

    const requiredTier = this.getRequiredTierForSku(normalizedSku);
    if (requiredTier === 'free' && !this.isNonAnonymousLogin(userData)) {
      return {
        sku: normalizedSku,
        isAllowed: false,
        requiredTier,
        effectiveTier,
        reason: 'Free tier requires signed-in account (guest login is not eligible)',
        grantedBy: 'none'
      };
    }

    if (requiredTier && this.tierGte(effectiveTier, requiredTier)) {
      return {
        sku: normalizedSku,
        isAllowed: true,
        requiredTier,
        effectiveTier,
        reason: `Allowed by ${effectiveTier} tier (requires ${requiredTier})`,
        grantedBy: 'tier'
      };
    }

    const trial = this.evaluateNewFeatureWindow(
      normalizedSku,
      userData?.firstLogin,
      now,
      userData?.isAnonymous
    );
    if (trial?.isEligible) {
      return {
        sku: normalizedSku,
        isAllowed: true,
        requiredTier,
        effectiveTier,
        reason: trial.reason,
        grantedBy: 'new-feature-window',
        validFrom: trial.validFrom,
        validUntil: trial.validUntil
      };
    }

    if (trial && !trial.isEligible) {
      return {
        sku: normalizedSku,
        isAllowed: false,
        requiredTier,
        effectiveTier,
        reason: trial.reason,
        grantedBy: 'none',
        validFrom: trial.validFrom,
        validUntil: trial.validUntil
      };
    }

    if (!requiredTier) {
      return {
        sku: normalizedSku,
        isAllowed: false,
        effectiveTier,
        reason: 'SKU is not mapped in access catalog',
        grantedBy: 'none'
      };
    }

    return {
      sku: normalizedSku,
      isAllowed: false,
      requiredTier,
      effectiveTier,
      reason: `Requires ${requiredTier} tier; current tier is ${effectiveTier}`,
      grantedBy: 'none'
    };
  }

  getEffectiveTier(userData?: AccessUserData | null): AccessTierName {
    return this.resolveEffectiveTier(userData);
  }

  buildAccessTable(userData: AccessUserData, now: Date = new Date()): SkuAccessDecision[] {
    const skus = Array.from(this.getKnownSkuUniverse()).sort((a, b) => a.localeCompare(b));
    return skus.map((sku) => this.checkAccess(sku, userData, now));
  }

  private resolveEffectiveTier(userData?: AccessUserData | null): AccessTierName {
    const declared = this.normalizeTier(userData?.tier);
    const purchased = this.computePurchasedTierFromList(userData?.purchasedProducts || this.getPurchasedProducts());
    return this.tierGte(declared, purchased) ? declared : purchased;
  }

  private normalizeTier(tier?: string | null): AccessTierName {
    if (!tier) return 'free';
    const t = `${tier}`.toLowerCase();
    if (t === 'gold' || t === 'silver' || t === 'bronze' || t === 'free') {
      return t;
    }
    return 'free';
  }

  private computePurchasedTierFromList(purchases?: PurchasedProductSnapshot[] | null): AccessTierName {
    const active = (purchases || []).filter((p) => p && p.isActive);
    for (const p of active) {
      const id = p.productId;
      if (this.goldSubscriptionSkus.has(id) || this.lifetimeGoldSkus.has(id)) {
        return 'gold';
      }
    }
    for (const p of active) {
      if (this.silverSubscriptionSkus.has(p.productId)) {
        return 'silver';
      }
    }
    return 'free';
  }

  private tierGte(left: AccessTierName, right: AccessTierName): boolean {
    return this.tierOrder[left] >= this.tierOrder[right];
  }

  private isNonAnonymousLogin(userData?: AccessUserData | null): boolean {
    return userData?.isAnonymous === false;
  }

  private getRequiredTierForSku(sku: string): AccessTierName | undefined {
    const normalizedSku = (sku || '').trim();
    if (!normalizedSku) return undefined;
    const freeSet = this.getFreeSkuSet();
    if (freeSet.has(normalizedSku)) return 'free';
    const bronzeSet = this.getBronzeSkuSet();
    if (bronzeSet.has(normalizedSku)) return 'bronze';
    const silverSet = this.getSilverSkuSet();
    if (silverSet.has(normalizedSku)) return 'silver';
    const known = this.getKnownSkuUniverse();
    if (known.has(normalizedSku)) return 'gold';
    return undefined;
  }

  private getKnownSkuUniverse(): Set<string> {
    const all = new Set<string>();
    const push = (items: Array<string | Features>) => {
      for (const item of items || []) {
        const value = `${item || ''}`.trim();
        if (value) all.add(value);
      }
    };

    push(freeTier.boardSku);
    push(freeTier.instrumentsSku);
    push(freeTier.features);
    push(bronzeTier.boardSku);
    push(bronzeTier.instrumentsSku);
    push(bronzeTier.features);
    push(silverTier.boardSku);
    push(silverTier.instrumentsSku);
    push(silverTier.features);
    push(allSkuInstr);

    for (const release of newFeatureSkuCatalog || []) {
      push(release.boardSkuList || []);
      push(release.instrumentSkuList || []);
      push(release.featuresSkuList || []);
    }
    return all;
  }

  private getFreeSkuSet(): Set<string> {
    return new Set<string>([
      ...(freeTier.boardSku || []),
      ...(freeTier.instrumentsSku || []),
      ...((freeTier.features || []) as unknown as string[])
    ]);
  }

  private getBronzeSkuSet(): Set<string> {
    return new Set<string>([
      ...(bronzeTier.boardSku || []),
      ...(bronzeTier.instrumentsSku || []),
      ...((bronzeTier.features || []) as unknown as string[])
    ]);
  }

  private getSilverSkuSet(): Set<string> {
    return new Set<string>([
      ...(silverTier.boardSku || []),
      ...(silverTier.instrumentsSku || []),
      ...((silverTier.features || []) as unknown as string[])
    ]);
  }

  private evaluateNewFeatureWindow(
    sku: string,
    firstLogin: Date | string | number | null | undefined,
    now: Date,
    isAnonymous?: boolean | null
  ): { isEligible: boolean; reason: string; validFrom?: string; validUntil?: string } | null {
    const candidates = (newFeatureSkuCatalog || []).filter((entry) => {
      const allSkus = [
        ...(entry.boardSkuList || []),
        ...(entry.instrumentSkuList || []),
        ...(entry.featuresSkuList || [])
      ];
      return allSkus.includes(sku);
    });

    if (candidates.length === 0) {
      return null;
    }

    if (isAnonymous !== false) {
      return {
        isEligible: false,
        reason: 'New-feature access requires signed-in account (guest login is not eligible)'
      };
    }

    const loginDate = this.toDate(firstLogin);
    if (!loginDate) {
      return {
        isEligible: false,
        reason: 'New-feature access disabled: first login date is missing'
      };
    }

    let best: { validUntil: Date; validFrom: Date; reason: string } | null = null;
    let latestMaxWindowEnd: Date | null = null;
    for (const entry of candidates) {
      const expiration = this.toDate(entry.expirationDate);
      if (!expiration) continue;
      const minimumDays = Math.max(0, Number(entry.minimumDays) || 0);
      const maxWindowEnd = this.addDays(expiration, minimumDays);
      if (!latestMaxWindowEnd || maxWindowEnd.getTime() > latestMaxWindowEnd.getTime()) {
        latestMaxWindowEnd = maxWindowEnd;
      }
      const cutoff = new Date(expiration.getTime());
      cutoff.setDate(cutoff.getDate() - minimumDays);

      const validFrom = new Date(loginDate.getTime());
      const computedUntil = loginDate.getTime() <= cutoff.getTime()
        ? expiration
        : this.addDays(validFrom, minimumDays);
      const validUntil = computedUntil.getTime() <= maxWindowEnd.getTime() ? computedUntil : maxWindowEnd;

      if (validUntil.getTime() < validFrom.getTime()) {
        continue;
      }

      if (!best || validUntil.getTime() > best.validUntil.getTime()) {
        best = {
          validUntil,
          validFrom,
          reason:
            loginDate.getTime() <= cutoff.getTime()
              ? `Allowed in new-feature window until ${this.toDateOnly(expiration)}`
              : `Allowed in new-feature minimum-days window until ${this.toDateOnly(validUntil)}`
        };
      }
    }

    if (!best) {
      if (latestMaxWindowEnd && now.getTime() > latestMaxWindowEnd.getTime()) {
        return {
          isEligible: false,
          reason: `New-feature trial expired on ${this.toDateOnly(latestMaxWindowEnd)}`,
          validUntil: this.toDateOnly(latestMaxWindowEnd)
        };
      }
      return {
        isEligible: false,
        reason: 'New-feature window is not configured correctly'
      };
    }

    if (now.getTime() <= best.validUntil.getTime()) {
      return {
        isEligible: true,
        reason: best.reason,
        validFrom: this.toDateOnly(best.validFrom),
        validUntil: this.toDateOnly(best.validUntil)
      };
    }

    return {
      isEligible: false,
      reason: `New-feature trial expired on ${this.toDateOnly(best.validUntil)}`,
      validFrom: this.toDateOnly(best.validFrom),
      validUntil: this.toDateOnly(best.validUntil)
    };
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
  }

  private toDateOnly(date: Date): string {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    const d = `${date.getDate()}`.padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
